import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ConsumptionModeType } from '@app/core/api-client/models';
import { ConsumptionMode, consumptionModes } from '@app/core/services/menu/models/consumption-mode.model';

@Component({
    selector: 'app-cart-consumption-mode',
    templateUrl: './cart-consumption-mode.component.html',
    styleUrls: ['./cart-consumption-mode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CartConsumptionModeComponent {

  @Input() readonly: boolean;

  consumptionModeModels: ConsumptionMode[];
  @Input()
  public set consumptionModes(value: ConsumptionModeType[]) {
    this.consumptionModeModels = value?.map(cm => consumptionModes.find(c => c.type === cm)).filter(c => !!c) as ConsumptionMode[];
  }

  selectedConsumptionModeModel: ConsumptionMode | null = null;
  @Input()
  public set consumptionMode(value: ConsumptionModeType) {
    this.selectedConsumptionModeModel = consumptionModes.find(c => c.type === value) || null;
  }

  @Output() consumptionModeChange = new EventEmitter<ConsumptionModeType>();

}
